// src/components/Layout/CommonHeader.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import M2TLogo from "../common/M2TLogo";

export default function BlogHeader() {
  const navigate = useNavigate();

  return (
    <header className="z-50 w-full border-gray-700 bg-black px-6 py-4 text-black">
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
      >
        {/* Logo scales with screen */}
        <M2TLogo className="h-[1.75rem] sm:h-[2.4rem] md:h-[2.8rem]" />
      </div>
    </header>
  );
}
